<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="医院名称" prop="hospitalName">
                <a-input v-model="queryParam.hospitalName" placeholder="请输入医院" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="状态" prop="status">
                <a-select v-model="queryParam.status" placeholder="请选择状态" allow-clear>
                  <a-select-option :value="0">待审核</a-select-option>
                  <a-select-option :value="1">通过</a-select-option>
                  <a-select-option :value="-1">驳回</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="科室名称" prop="departName">
                  <a-input v-model="queryParam.departName" placeholder="请输入科室" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="姓名" prop="name">
                  <a-input v-model="queryParam.name" placeholder="请输入姓名" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="职称" prop="professional">
                  <a-select v-model="queryParam.professional" placeholder="请选择职称" allow-clear>
                    <a-select-option v-for="dict in dict.type.doctor_professional" :key="dict.value" :value="dict.value">
                      {{ dict.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="updateTime" slot-scope="text, record">
          {{ parseTime(record.updateTime) }}
        </span>
        <span slot="logo" slot-scope="text, record">
          <img v-viewer v-if="record.logo" :src="processImageUrl(record.logo)" style="width: 50px; height: 50px; cursor: pointer; border-radius: 4px;">
          <span v-else style="color: #999;">暂无</span>
        </span>
        <span slot="sex" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_user_sex']" :value="record.sex"/>
        </span>
        <span slot="professional" slot-scope="text, record">
          <dict-tag :options="dict.type['doctor_professional']" :value="record.professional"/>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="record.status === 0" color="orange">待审核</a-tag>
          <a-tag v-else-if="record.status === 1" color="green">通过</a-tag>
          <a-tag v-else-if="record.status === -1" color="red">
            驳回
            <a-tooltip v-if="record.rejectReason" :title="record.rejectReason" placement="right">
              <a-icon type="info-circle" style="margin-left: 4px; cursor: pointer;" />
            </a-tooltip>
          </a-tag>
        </span>
        <span slot="rejectReason" slot-scope="text, record">
          <template v-if="record.rejectReason">
            <a-tooltip :title="record.rejectReason" placement="topLeft">
              <span class="reject-reason-text">{{ record.rejectReason }}</span>
            </a-tooltip>
          </template>
          <span v-else style="color: #999;">-</span>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-space>
            <a v-if="record.status == 0" @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['doctor:auth:edit']">
              <a-icon type="audit" />审核
            </a>
            <a v-else @click="$refs.createForm.handleInfo(record)" v-hasPermi="['doctor:auth:query']">
              <a-icon type="eye" />详情
            </a>
            <a @click="handleDelete(record)" v-hasPermi="['doctor:auth:remove']">
              <a-icon type="delete" />删除
            </a>
          </a-space>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageAuth, listAuth, delAuth } from '@/api/doctor/auth'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { processImageUrl } from '@/utils/util'

export default {
  name: 'Auth',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  dicts: ['sys_user_sex', 'doctor_professional'],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        userId: null,
        nickname: null,
        hospitalName: null,
        hospitalId: null,
        departName: null,
        departId: null,
        name: null,
        sex: null,
        certify: null,
        logo: null,
        workYear: null,
        professional: null,
        honor: null,
        strongPoint: null,
        content: null,
        certificate: null,
        status: null,
        rejectReason: null,
        score: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '医院名称',
          dataIndex: 'hospitalName',
          ellipsis: true,
          align: 'center',
          width: 150
        },
        {
          title: '科室名称',
          dataIndex: 'departName',
          ellipsis: true,
          align: 'center',
          width: 120
        },
        {
          title: '姓名',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center',
          width: 80
        },
        {
          title: '性别',
          dataIndex: 'sex',
          ellipsis: true,
          align: 'center',
          width: 60,
          scopedSlots: { customRender: 'sex' }
        },
        {
          title: '医师形象照片',
          dataIndex: 'logo',
          ellipsis: true,
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'logo' }
        },
        {
          title: '工龄',
          dataIndex: 'workYear',
          ellipsis: true,
          align: 'center',
          width: 70
        },
        {
          title: '职称',
          dataIndex: 'professional',
          ellipsis: true,
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'professional' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '申请时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          ellipsis: true,
          align: 'center',
          width: 150
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 150,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    processImageUrl,
    /** 查询医师认证信息列表 */
    getList () {
      this.loading = true
      pageAuth(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        nickname: undefined,
        hospitalName: undefined,
        hospitalId: undefined,
        departName: undefined,
        departId: undefined,
        name: undefined,
        sex: undefined,
        certify: undefined,
        logo: undefined,
        workYear: undefined,
        professional: undefined,
        honor: undefined,
        strongPoint: undefined,
        content: undefined,
        certificate: undefined,
        status: undefined,
        rejectReason: undefined,
        score: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delAuth(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('doctor/auth/export', {
            ...that.queryParam
          }, `医师认证信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style scoped>
.reject-reason-text {
  max-width: 150px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
</style>
